angular.module('storefrontApp').controller('rsHelpPopupController', [
    '$http',
    '$sce',
    '$cacheFactory',
    function ($http, $sce, $cacheFactory) {
        const vm = this;
        const cache = $cacheFactory.get('rsHelpPopup') || $cacheFactory('rsHelpPopup');

        vm.content = cache.get('content');

        vm.load = function () {
            if (vm.content || vm.loading) {
                return;
            }

            let pending = cache.get('pending');
            if (pending) {
                vm.loading = true;
                pending.then(function (trusted) {
                    vm.content = trusted;
                }).finally(function () {
                    vm.loading = false;
                });
                return;
            }

            if (!vm.url) {
                return;
            }

            vm.loading = true;
            pending = $http.get(vm.url)
                .then(function (response) {
                    const doc = new DOMParser().parseFromString(response.data, 'text/html');
                    const rte = doc.querySelector('.rte');
                    if (!rte) {
                        return null;
                    }
                    const trusted = $sce.trustAsHtml(rte.innerHTML);
                    cache.put('content', trusted);
                    return trusted;
                });
            cache.put('pending', pending);

            pending.then(function (trusted) {
                if (trusted) {
                    vm.content = trusted;
                }
            }).finally(function () {
                vm.loading = false;
            });
        };
    },
]);
